<template>
	<ValidationProvider
		v-slot="{ errors, ariaInput, ariaMsg }"
		:name="name || label"
		:rules="rules"
		:vid="vid"
		class="text-input-wrap"
		tag="div"
	>
		<label
			v-if="!isHiddenLabel && (label || name)"
			:class="{ 'validation-error': errors[0] }"
			:for="name"
			class="text-input-label"
			@click="$refs.input.focus()"
		>
			<span>{{ label }}</span>
		</label>

		<div class="text-input-holder">
			<select
				:id="name"
				ref="input"
				:class="{ 'validation-error': errors[0], 'has-value': hasValue }"
				:disabled="disabled"
				:value="value"
				class="text-input"
				v-bind="ariaInput"
				@change="updateValue($event.target.value)"
			>
				<option v-if="placeholder" :value="null" disabled hidden>
					{{ placeholder }}
				</option>
				<template v-for="option in options">
					<template v-if="typeof option === 'object'">
						<option
							v-if="!option.hidden"
							:key="option[keyValue]"
							:disabled="option.disabled"
							:value="option[keyValue]"
						>
							{{ option[labelValue] }}
						</option>
					</template>
					<option v-else :key="option" :value="option">
						{{ option }}
					</option>
				</template>
			</select>
			<div v-if="errors[0]" class="text-input-errors">
				<span v-bind="ariaMsg">
					{{ errors[0] }}
				</span>
			</div>
		</div>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
	name: 'OptionsSelect',
	components: {
		ValidationProvider
	},
	props: {
		vid: {
			type: String,
			// eslint-disable-next-line no-undefined
			default: undefined
		},
		name: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		rules: {
			type: [Object, String],
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		value: {
			type: null,
			default: ''
		},
		options: {
			type: [Array, Number],
			default: () => []
		},
		keyValue: {
			type: String,
			default: 'id'
		},
		labelValue: {
			type: String,
			default: 'title'
		},
		disabled: {
			type: Boolean,
			default: false
		},
		isHiddenLabel: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		hasValue () {
			return Boolean(this.value)
		}
	},
	methods: {
		updateValue (value) {
			this.$emit('input', value)
		}
	}
}
</script>
